import { Typography, Box, Tooltip } from '@mui/material';
import Colors from 'constants/colors';

interface DetailItemTypes {
    label?: string;
    value?: string | number;
    labelWidth?: string | number;
    textAlign?: string;
    fontWeight?: string | number;
    width?: string | number;
}

// eslint-disable-next-line react/prop-types
const DetailItem: React.FC<DetailItemTypes> = ({ width, label, value, labelWidth, textAlign = 'left', fontWeight = 'bold' }) => (
    <Box width={width || '100%'} sx={{ my: 1 }}>
        <Typography sx={{ display: 'flex', flexDirection: 'row' }} variant="body1">
            <Typography
                sx={{
                    width: labelWidth || '30%',
                    color: Colors.darkTextColor,
                    textAlign: 'left',
                    fontSize: { xs: 12, sm: 14 },
                    fontWeight: '400',
                    '@media (max-width: 600px)': { width: '100%' },
                }}
                component="span"
            >
                {label && `${label}:`}
            </Typography>
            <Tooltip title={value}>
                <Typography
                    sx={{
                        textAlign: textAlign || 'right',
                        width: '70%',
                        fontWeight: fontWeight,
                        color: Colors.darkTextColor,
                        fontSize: { xs: 10, sm: 14 },
                        wordWrap: 'break-word',
                        overflow: 'hidden',
                    }}
                    maxHeight={'16ch'}
                    textOverflow={'ellipsis'}
                    component="span"
                >
                    {value}
                </Typography>
            </Tooltip>
        </Typography>
    </Box>
);

export default DetailItem;
